var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-three-quarters"},[_c('svg',{staticClass:"sunburst",attrs:{"id":"dataviz_area","height":"400","width":"400"}})]),_c('div',{staticClass:"column sunburst-annotation"},[_c('svg',{staticClass:"sunburst-annotation",attrs:{"id":"annotation_area","height":"400","width":"300"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }